import { TextField as MUITextField, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  DistrictField,
  ProvinceField,
  SubDistrictField,
  useAddress,
  ZipcodeField,
} from "components/request-document/components/Address";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function ContactPersonSection({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            {/* <div>
              <Typography>Full English name as in passport</Typography>
            </div> */}
          </div>
        </StyledTableCell>
      </TableRow>
      {/* <TableRow>
        <StyledTableCell colSpan={12}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Occupation</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.PersonalOccupation"
                value={formik.values.document.PersonalOccupation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.PersonalOccupation", formik)}
                helperText={getErrorMessage(
                  "document.PersonalOccupation",
                  formik
                )}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow> */}

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Name of contact person in Thailand</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.ContactPersonInThai"
                value={formik.values.document.ContactPersonInThai}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.ContactPersonInThai", formik)}
                helperText={getErrorMessage(
                  "document.ContactPersonInThai",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Relationship with the applicant</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.ContactRelationship"
                value={formik.values.document.ContactRelationship}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.ContactRelationship", formik)}
                helperText={getErrorMessage(
                  "document.ContactRelationship",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>E-mail address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.ContactEmail"
                value={formik.values.document.ContactEmail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.ContactEmail", formik)}
                helperText={getErrorMessage("document.ContactEmail", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Mobile phone number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.ContactMobile"
                inputProps={{ maxLength: 10 }}
                onKeyDown={(e) => {
                  const pattern = /[^0-9]/g;
                  const isNotAllow = e.key.length === 1 && pattern.test(e.key);

                  if (isNotAllow) {
                    e.preventDefault();
                  }
                }}
                value={formik.values.document.ContactMobile}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.ContactMobile", formik)}
                helperText={getErrorMessage("document.ContactMobile", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
